import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  flex?: Boolean;
  selected?: boolean;
  transparent?: boolean;
  marginTop?: string;
  height?: number;
}

export const LoaderContainer = styled.div`
`

export const DesignsContainer = styled.div`
  box-sizing: border-box;
  margin: ${(props: IRootProps) => props.marginTop ? `${props.marginTop} 0 0 0` : '10px 0 0 0'};
  width: 100%;
  position: relative;
  height: ${(props: IRootProps) => props.height && `calc(100vh - ${props.height}px)`};
  overflow-y: auto;
`
export const DesignsWrap = styled.div`
  .group-list {
    padding: 8px;
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
`
export const EmptyContainer = styled.div`
  box-sizing: border-box;
  margin: 10px 0 0 0;
  width: 100%;
  position: relative;
  height:350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #c9c9c9;
`

export const PreviewContainer = styled.div`
  flex: 1;
  height: 140px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  border-radius: 5px;
  background-color: ${C.WHITE};    
  border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid white`)};
  cursor: pointer;
  transition: transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: scale(1.05);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid rgba(32, 64, 120, 0.3)`)};
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);    
  }
  margin-bottom: 28px;
`;

interface IProps {
  zIndexValue?: string;
  positionValue?: string;
  opacityValue?: string;
  transparent?: boolean;
}

export const ImgContainer = styled.img`
  height: 110px;
  display: flex;
  
  width: 85%;
  text-align: center;
  object-fit: contain;
  box-sizing: border-box;
  ${(props: IRootProps) => (props.transparent ? `{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
    background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  }` : ``)};
    
`;

export const ImgTitle = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-top:4px;
  color: #8891a0;
  `;

  export const radioContainer = styled.div`
  display:flex;
  margin-top:20px;
  
  width:100%;
`;